import type { AppConfig, ThreatColorMap, ThreatNameMap, City } from '@/types';

/** Application configuration */
export const CONFIG: AppConfig = {
  websocketUrl: 'ws://localhost:8080/flows',
  arcLifetime: 2000,
  emberLifetime: 60000,
  maxArcs: 1000,
  maxEmbers: 5000,
  maxFlowsPerFrame: 500,
  flowProcessBudgetMs: 6,
  globeImageUrl: 'https://unpkg.com/three-globe@2.30.0/example/img/earth-night.jpg',
  targetFPS: 60,
  maxEventFeedItems: 100,
  sparklinePoints: 30,
} as const;

/** Threat level to RGB color mapping */
export const THREAT_COLORS: ThreatColorMap = {
  0: { r: 0, g: 255, b: 150 },
  1: { r: 150, g: 255, b: 0 },
  2: { r: 255, g: 255, b: 0 },
  3: { r: 255, g: 165, b: 0 },
  4: { r: 255, g: 50, b: 0 },
  5: { r: 255, g: 0, b: 50 },
} as const;

/** Threat level to name mapping */
export const THREAT_NAMES: ThreatNameMap = {
  0: 'Safe',
  1: 'Low',
  2: 'Medium',
  3: 'High',
  4: 'V.High',
  5: 'Critical',
} as const;

/** Demo mode cities */
export const DEMO_CITIES: readonly City[] = [
  { name: 'New York', lat: 40.7128, lng: -74.0060 },
  { name: 'London', lat: 51.5074, lng: -0.1278 },
  { name: 'Tokyo', lat: 35.6762, lng: 139.6503 },
  { name: 'Sydney', lat: -33.8688, lng: 151.2093 },
  { name: 'Moscow', lat: 55.7558, lng: 37.6173 },
  { name: 'Mumbai', lat: 19.0760, lng: 72.8777 },
  { name: 'Sao Paulo', lat: -23.5505, lng: -46.6333 },
  { name: 'Cairo', lat: 30.0444, lng: 31.2357 },
  { name: 'Singapore', lat: 1.3521, lng: 103.8198 },
  { name: 'Los Angeles', lat: 34.0522, lng: -118.2437 },
  { name: 'Las Vegas', lat: 36.1699, lng: -115.1398 },
] as const;

/** Default point of view for globe */
export const DEFAULT_POV = {
  lat: 7,
  lng: 0,
  altitude: 2.5,
} as const;
